
import React ,{ useState, useEffect } from 'react';

const Admin = () => {

  const [links, setLinks] = useState({});
  const [accept, setAccept] = useState(null);
  const [reject, setReject] = useState(null);
  const [error, setError] = useState(null);
  const [message, setMessage]= useState(null);
  const linkCount = Object.keys(links).length;



  useEffect(() => {
    // APIのエンドポイントを指定

    fetch('/req_api/admin.php?accept='+accept+'&reject='+reject) 
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // 取得したJSONデータをstateにセット
        setLinks(data.links);
        setMessage(data.message);
        //const linkCount = Object.keys(links).length;
      })
      .catch(error => {
        setError(error);
        console.error('Error fetching adminlist:', error);
      });
  }, [accept,reject]);

  return (
    <main>
      <section id="admin">
        <div id="admin_inner">         

            
            <h2>サイト登録</h2>

            {message && <div dangerouslySetInnerHTML={{__html: message}} />}

            {linkCount === 0 ? (
            // 0件の場合
            <p className="no-items-message">現在、承認待ちの登録はありません。</p>
            ) : (
            <ul>
              {Object.keys(links).map(key => (
                <li key={key}>
                      
                        <img 
                          src={links[key].site_img ? `/upload/${links[key].site_img}`: '/upload/no_img.png'}
                          alt={links[key].site_name} 
                        />            
                        <h3 className='ttl'>{links[key].site_name}</h3>
                        <p>{links[key].site_detail}</p>
                        <p className='linkid'><a href={`${links[key].site_url}`} target="_blank">{links[key].site_url}</a></p>

                        <div className='btns'>
                        <p className="auth" onClick={() => {
                            if (typeof window !== 'undefined' && window.confirm(`「${links[key].site_name}」のサイト登録を許可しますか？`)) {
                                setAccept(`${links[key].site_id}`);
                                setReject(null);
                            }
                        }}>許可する</p>
                        <p className="del" onClick={() => {                        
                          if (typeof window !== 'undefined' && window.confirm(`「${links[key].site_name}」の登録を削除しますか？`)) {
                                setReject(`${links[key].site_id}`);
                                setAccept(null);
                          }
                        }}>削除する</p>
                        </div>
                     
                </li>
              ))}
            </ul>
            )}
        </div>
      </section>
    </main>
  );
};

export default Admin;